import SiteEnum from '@models/enums/SiteEnum';
import { IBrandsAndSolutionsListing } from '@models/IBrandsAndSolutionsListing';
import ArticleListing from '@molecules/ArticleListing/ArticleListing';

const BrandsAndSolutionsListing = (props: IBrandsAndSolutionsListing) => {
  return (
    <ArticleListing
      {...props}
      pageSize={12}
      searchEndpoint={`${props.searchEndpoint}/list`}
      initialItems={props.items}
      site={SiteEnum.B2B}
    />
  );
};

export default BrandsAndSolutionsListing;
